let progress = document.querySelectorAll('[data-progress]');

progress.forEach(function(el) {
    el.style.width = el.dataset.progress + '%';
    el.classList.remove('d-none');
});
